export default __webpack_public_path__ + "c6a9a2b90e8c54aa3b0c5959c64cf1c3.png";